//RUTAS COMBUSTIBLE
export const urlCreateFuel = "/api/vehicles/fuel";
export const urlDetailFuel = "/api/vehicles/search/fuel";
export const urlEditFuel = "/api/vehicles/fuel";
